import { useRef, useState } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { addStepLogMessage } from "src/data/keikka/handleKeikka";
import PropTypes from "prop-types";
import MySkeleton from "src/components/layout/MySkeleton";
import { aikaPvmStringLong } from "src/components/js/statics1";
import { allowEditTilausData } from "src/data/ifs/allowIfs";
import IconsContainer from "src/components/icons/others/IconsContainer";
import { useUserData } from "src/context/userContext";
import { keikka_comment_save_to_db } from "src/data/keikka/KeikkaFunctions";

const styles = {
  txt: {
    paddingTop: "5px",
    whiteSpace: "pre-line",
    transition: "all 1.5s ease-in-out",
  },
  otsikko: { paddingRight: "5px" },
};

export default function HuomRow(props) {
  const inputRefEdit = useRef(null);
  const inputRefAdd = useRef(null);
  const keikkaData = props.keikkaData;
  const { socket, user, token } = useUserData();

  const [isEditing, setEditing] = useState(false);
  const [isAdding, setAdding] = useState(false);
  const [prevKeyCode, setPrevKeyCode] = useState(0);
  const [originalComment, setOriginalComment] = useState(keikkaData.keikkaComment);
  const [addingText, setAddingText] = useState("");

  const handleEditClick = () => {
    setOriginalComment(keikkaData.keikkaComment);
    if (keikkaData.auth.edit) {
      setEditing(true);
      //inputRefEdit.current.focus();
    } else {
      setAdding(true);
      //inputRefAdd.current.focus();
    }
  };

  const handleTextChange = (event) => {
    if (isAdding) {
      setAddingText(event.target.value);
    } else {
      keikkaData.keikkaComment = event.target.value;
    }
    props.setKeikkaData(keikkaData);
  };

  const onKeyDown = (e) => {
    if (
      (keikkaData.keikkaComment == null ||
        keikkaData.keikkaComment.length < 2 ||
        prevKeyCode === 13) &&
      e.keyCode === 13
    ) {
      e.preventDefault();
      handleSaveClick();
    }
    setPrevKeyCode(e.keyCode);
  };

  const handleSaveClick = async () => {
    if (isEditing) {
      setEditing(false);
    }
    if (isAdding) {
      setAdding(false);
      const pvm = aikaPvmStringLong(null, true);
      if (keikkaData.keikkaComment == null || keikkaData.keikkaComment.length < 2)
        keikkaData.keikkaComment = pvm + " " + addingText;
      else keikkaData.keikkaComment += "\n" + pvm + " " + addingText;
    }
    props.setKeikkaData(keikkaData);
    const personId = user.personId;
    await keikka_comment_save_to_db(keikkaData, token, socket);
    addStepLogMessage(
      keikkaData,
      socket,
      personId,
      {
        title: "Huomio tilaukseen:" + keikkaData.keikkaId,
        body: keikkaData.keikkaComment.slice(-500), // 500 char limit
      },
      13, // huomio
      true, // add only if varmenne changed
      false, // not system message
      isAdding ? true : undefined // lähetä aina ilmoitukset kun lisätään huomioita, riippumatta keikkaTilasta
    );
  };

  const handleCancelClick = async () => {
    setEditing(false);
    setAdding(false);
    keikkaData.keikkaComment = originalComment;
    props.setKeikkaData(keikkaData);
  };

  const label = "Huomioita" + (isAdding ? " (lisätään)" : "");

  const editingTextField = (
    <TextField
      id="outlined-multiline-flexible"
      label={label}
      multiline
      fullWidth
      defaultValue={keikkaData.keikkaComment || ""}
      onChange={handleTextChange}
      //inputProps={{ maxLength: 499 }}
      onKeyDown={onKeyDown}
      inputRef={inputRefEdit}
    />
  );
  const addingTextField = (
    <div style={{ paddingTop: "6px" }}>
      <TextField
        id="outlined-multiline-flexible"
        label={label}
        multiline
        fullWidth
        defaultValue={""}
        onChange={handleTextChange}
        //inputProps={{ maxLength: 499 }}
        onKeyDown={onKeyDown}
        inputRef={inputRefAdd}
      />
    </div>
  );
  return (
    <>
      <Button
        variant="text"
        fullWidth
        onClick={() => handleEditClick()}
        disabled={isEditing || isAdding}
        aria-label="Muokkaa huomioita"
        sx={{ margin: 0, padding: 0 }}
        className="stepRow">
        <Grid container sx={{ width: "100%" }}>
          {RenderHuomioitaTextGridCell(3)}
          {(keikkaData.keikkaId === 0 || keikkaData.isLoading) && (
            <MySkeleton width="70%" height="40px" />
          )}
          {RenderKeikkaCommentGridCell(isEditing ? 9 : 7)}
          {RenderEditIconGridCell(2)}
        </Grid>
      </Button>

      <Grid container sx={{ width: "100%" }}>
        <Grid size={{ xs: 3 }} />
        <Grid size={{ xs: 9 }} sx={{ textAlign: "left" }}>
          {isEditing && editingTextField}
          {isAdding && addingTextField}
        </Grid>
      </Grid>

      {(isEditing || isAdding) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}>
          <Button
            variant="outlined"
            onClick={() => {
              handleCancelClick();
            }}
            sx={{ margin: "5px" }}
            aria-label="Peruuta">
            PERUUTA
          </Button>
          <Button
            variant="contained"
            onClick={() => handleSaveClick()}
            sx={{ margin: "5px" }}
            aria-label="Tallenna">
            {isAdding ? "LISÄÄ HUOMIO" : "TALLENNA HUOMIO"}
          </Button>
          <br />
          <br />
        </div>
      )}
    </>
  );

  function RenderHuomioitaTextGridCell(width) {
    return (
      <Grid size={{ xs: width }} sx={{ textAlign: "right" }}>
        <Typography variant="h6" sx={styles.otsikko} noWrap color="primary" className="fixPrint">
          <span className={keikkaData.keikkaComment == "" ? "noPrint" : ""}>Huomioita:</span>
        </Typography>
      </Grid>
    );
  }

  function RenderKeikkaCommentGridCell(width) {
    return (
      <Grid size={{ xs: width }} sx={{ textAlign: "left" }}>
        {!isEditing && (
          <Typography sx={styles.txt} color="primary" className="fixPrint">
            {keikkaData.keikkaCommentString()}
          </Typography>
        )}
      </Grid>
    );
  }

  function RenderEditIconGridCell(width) {
    return (
      <Grid size={{ xs: width }} className="frontPageEditIcon">
        <div className="noPrint">
          <IconsContainer showEdit={allowEditTilausData(keikkaData)} editOpacity={0.5} />
        </div>
      </Grid>
    );
  }
}

HuomRow.propTypes = {
  keikkaData: PropTypes.object,
  setKeikkaData: PropTypes.func,
};
